import { useEffect, useState } from "react";
import axios from "axios";
import { RatSvg } from "./RatLayer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PRIDE = ["#FF0000", "#FF9900", "#FFEE00", "#33CC33", "#3399FF", "#CC66FF"];

const ElfSvg = () => (
  <svg width="58" height="106" viewBox="0 0 60 110" fill="none">
    <path d="M13 22 L2 11 L15 15 Z" fill="#F2C094" />
    <path d="M47 22 L58 11 L45 15 Z" fill="#F2C094" />
    <circle cx="30" cy="24" r="12" fill="#F2C094" />
    <path d="M27 20 L31 16 L33 21 Z" fill="#C98D5E" />
    <path
      d="M8 52 C 10 42 20 38 30 38 C 40 38 50 42 52 52 L 48 84 C 46 92 38 96 30 96 C 22 96 14 92 12 84 Z"
      fill="#F2C094"
    />
    <path d="M18 54 Q 24 59 30 54 Q 36 59 42 54" stroke="#C98D5E" strokeWidth="2" fill="none" />
    <path d="M26 64 L26 88 M34 64 L34 88 M22 72 L38 72 M22 80 L38 80" stroke="#C98D5E" strokeWidth="1.5" />
    <path d="M10 50 C 4 40 2 32 5 22" stroke="#F2C094" strokeWidth="7" strokeLinecap="round" fill="none" />
    <path d="M50 50 C 56 40 58 32 55 22" stroke="#F2C094" strokeWidth="7" strokeLinecap="round" fill="none" />
    <circle cx="5" cy="20" r="4" fill="#F2C094" />
    <circle cx="55" cy="20" r="4" fill="#F2C094" />
  </svg>
);

const MiniBottle = () => (
  <svg width="38" height="54" viewBox="0 0 60 85" className="bottle-float">
    <rect x="21" y="2" width="18" height="10" rx="2" fill="#E50000" />
    <rect x="24" y="12" width="12" height="8" fill="#FFD800" />
    <rect x="12" y="20" width="36" height="61" rx="9" fill="#FFD800" stroke="#FF71CE" strokeWidth="3" />
    <path d="M33 27 L24 47 L30 47 L27 61 L38 41 L31 41 Z" fill="#E50000" />
  </svg>
);

const Rainbow = ({ className }) => (
  <svg viewBox="0 0 200 104" className={className} data-testid="fruit-rainbow-arc">
    {PRIDE.map((c, i) => (
      <path
        key={c}
        d={`M ${8 + i * 8} 102 A ${94 - i * 8} ${94 - i * 8} 0 0 1 ${192 - i * 8} 102`}
        stroke={c}
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
      />
    ))}
  </svg>
);

export const FruitParty = () => {
  const [guests, setGuests] = useState([]);

  useEffect(() => {
    const fetchGuests = () =>
      axios
        .get(`${API}/guests/aliases`)
        .then((res) => setGuests(res.data.aliases.filter(Boolean)))
        .catch(() => {});
    fetchGuests();
    const id = setInterval(fetchGuests, 15000);
    return () => clearInterval(id);
  }, []);

  const shown = guests.slice(0, 12);
  const floor = [];
  for (let i = 0; i < 14; i++) {
    floor.push({ type: "elf", key: `elf-${i}`, i });
    if (shown.length && i % 2 === 1) {
      const g = shown[(i >> 1) % shown.length];
      if ((i >> 1) < shown.length) floor.push({ type: "guest", key: `guest-${g}`, alias: g, i });
    }
  }

  return (
    <>
      <div className="dancefloor-glow" data-testid="dancefloor-glow" />
      <div
        className="fixed bottom-0 inset-x-0 z-[2] pointer-events-none flex justify-center items-end overflow-hidden"
        data-testid="elf-dancefloor"
      >
        {floor.map((item) =>
          item.type === "elf" ? (
            <div
              key={item.key}
              className="elf-dance shrink-0"
              style={{
                animationDelay: `${(item.i % 5) * 0.18}s`,
                animationDuration: `${0.85 + (item.i % 3) * 0.16}s`,
                transform: `scale(${0.85 + (item.i % 4) * 0.08})`,
                opacity: 0.9,
              }}
            >
              <ElfSvg />
            </div>
          ) : (
            <div
              key={item.key}
              className="elf-dance shrink-0 flex flex-col items-center"
              style={{
                animationDelay: `${(item.i % 4) * 0.22}s`,
                animationDuration: `${0.75 + (item.i % 3) * 0.14}s`,
              }}
              data-testid={`guest-dancer-${item.alias}`}
            >
              <span
                className="text-[8px] font-mono tracking-wider text-[#FFFB96] mb-0.5 whitespace-nowrap"
                style={{ textShadow: "0 0 6px rgba(0,0,0,0.9)" }}
                data-testid={`guest-dancer-name-${item.alias}`}
              >
                {item.alias}
              </span>
              <div className="rat-rainbow">
                <RatSvg size={42} />
              </div>
            </div>
          )
        )}
      </div>
      {guests.length > 12 && (
        <div className="fixed bottom-28 right-6 z-[2] pointer-events-none text-[9px] font-mono tracking-[0.25em] uppercase text-[#FFFB96]/70" data-testid="guest-dancer-overflow">
          +{guests.length - 12} more in the pit
        </div>
      )}

      <Rainbow className="fruit-rainbow rainbow-a" />
      <Rainbow className="fruit-rainbow rainbow-b" />

      {[0, 1, 2].map((i) => (
        <div key={i} className={`mini-bottle mini-bottle-${i}`} data-testid={`mini-bottle-${i}`}>
          <MiniBottle />
        </div>
      ))}
    </>
  );
};
